/**
 * アプリケーションのメインエントリーポイント
 * Vue 2アプリケーションの初期化とグローバル設定を行う
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import format from "vue-text-format";
Vue.use(format);
import App from "./App";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/ja";

import Suggestions from "@/components/v-suggestions/src/Suggestions.vue";

import "../static/jquery-migrate-1.2.1";
import "../static/jquery.i18n.properties-1.0.9";
import "../static/ui.datepicker-ja";
import "../static/ui.datepicker-zh-CN";
import "../static/json-minified";
import "../static/jquery.cookie";
import "../static/select2";
import "../static/alertify.min";
import "../static/colorpicker";
import "./assets/css/default.css";
import "./assets/css/bootstrap.css";
import "./assets/ingrid/ingrid.css";
import "./assets/ingrid/ingrid_black.css";
import "./assets/ingrid/ingrid_cool.css";

import "./assets/css/v-suggestions.css"; // you can import the stylesheets also (optional)

// 引入第三方图标库
import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.component('suggestions', Suggestions);

if (process.env.NODE_ENV === "development") {
  jQuery.i18n.properties({
    name: "saasforce",
    path: "../static/i18n/",
    mode: "both",
    language: "ja",
    cache: false,
    callback: function () {},
  });
} else {
  jQuery.i18n.properties({
    name: "saasforce",
    path: "./static/i18n/",
    mode: "both",
    language: "ja",
    cache: false,
    callback: function () {},
  });
}
//Vue.use(ElementUI);
Vue.use(ElementUI, { locale });
Vue.use(require("vue-moment"));
Vue.use(require("vuex"));

// 共通ユーティリティをインポート
import { numberUtils } from "./utils/common.js";

Vue.filter("number_format", function (value) {
  return numberUtils.formatNumber(value);
});

// 遅延読み込みディレクティブを登録
import { lazyLoad } from "./directives/lazy-load.js";
Vue.directive('lazy', lazyLoad);

// アプリケーションキャッシュをグローバルに登録
import appCache from "./utils/app-cache.js";
Vue.prototype.$appCache = appCache;

// グローバルローディングメソッドを追加
Vue.prototype.$showLoading = function(text = 'データを読み込み中...') {
  // Element UIのローディングを使用
  this.$loading({
    lock: true,
    text: text,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};

Vue.prototype.$hideLoading = function() {
  // ローディングを隠す
  const loadingInstance = this.$loading();
  if (loadingInstance) {
    loadingInstance.close();
  }
};

Vue.prototype.$updateLoadingText = function(text) {
  // ローディングテキストを更新（Element UIでは直接サポートされていないため、再表示）
  this.$hideLoading();
  this.$showLoading(text);
};

Vue.prototype.$isLoadingVisible = function() {
  // ローディングが表示されているかチェック
  return document.querySelector('.el-loading-mask') !== null;
};

import less from "less";

//echarts
//import echarts from 'echarts'
//Vue.prototype.$echarts = echarts

Vue.use(less);

Vue.prototype.$delCookie = delCookie;

/**
 * Cookieから指定された名前の値を取得する
 * @param {string} name - 取得するCookieの名前
 * @returns {string|null} Cookieの値、存在しない場合はnull
 */
function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
}

/**
 * 指定された名前のCookieを削除し、ログインページにリダイレクトする
 * @param {string} name - 削除するCookieの名前
 */
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    router.push({ path: "/login" });
  }
}

if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "production-local") {
  window.replaceUrl = "/api";
  urlImport = "/api/s/importdirect";
  urlPrintExcel = "/api/s/ExcelFile";
  urlExport = "/api/s/Export";
} else {
  window.replaceUrl = process.env.SERVER_URL + "api/";
  urlImport = "/api/s/importdirect";
  urlPrintExcel = "/api/s/ExcelFile";
  urlExport = "/api/s/Export";
}

// Vue.prototype.$18n=i18n;

Vue.config.productionTip = false;

// 为静态函数设置根url
__baseurl = process.env.ROOT_BASE;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js